<template>
    <div>
      <textarea :id="id" ref="tinymce" :name="name" :placeholder="placeholder" class="vue-tinymce">
          {{content}}
      </textarea>
    </div>
</template>
<script>
import {EventBus} from "@/events/event-bus";

export default {
    name: 'TinyMceEitor',
    props: {
        name: null,
        path: null,
        placeholder: null,
        value: null,
        isServiceDescription: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data: function () {
        return {
            id: this.makeId(10),
            editorConfig: {},
            dirtyContent: '',
            content: this.value
        }
    },
    methods: {
        loadScript(url, callback) {
            var list = document.getElementsByTagName('script');
            //Search for tinymce.min.js if already loaded before in the page
            var i = list.length, flag = false;
            while (i--) {
                if (list[i].src === url && list[i].dataset.loaded) {
                    flag = true;
                    break;
                }
            }
            //if we load tinymce.min.js more than once after it's already loaded (in case ajax) it not init new ones
            // if we didn't already find it on the page, add it
            if (!flag) {
                var script = document.createElement("script")
                script.type = "text/javascript";

                if (script.readyState) {  // only required for IE <9
                    script.onreadystatechange = function () {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            script.dataset.loaded = true;
                            callback();
                        }
                    };
                } else {  //Others
                    script.onload = function () {
                        script.dataset.loaded = true;
                        callback();
                    };
                }
                script.src = url;
                document.getElementsByTagName("head")[0].appendChild(script);
            } else {
                callback();
            }

        },
        makeId(length) {
            var result = '';
            var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            var characters = letters + '0123456789';
            // CSS IDs must not start with a digit — always use a letter as the first character
            result += letters.charAt(Math.floor(Math.random() * letters.length));
            for (var i = 1; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        },
        cleanTinyMcePlugins(plugins) {
            const blockedPlugins = ['print', 'fullpage'];

            if (!plugins) {
                return '';
            }

            if (Array.isArray(plugins)) {
                plugins = plugins.join(' ');
            }

            return String(plugins)
                .split(/[,\s]+/)
                .filter(Boolean)
                .filter(plugin => !blockedPlugins.includes(plugin))
                .join(' ');
        },
        initTinyMCE() {
            const vm = this;
            const selector = '#' + vm.id;
            $("#tinymceScript").ready(function () {
                // setTimeout(() => {
                tinymce.init(vm.editorConfig).then(function (editor) {
                    console.log('TinyMCE final plugins:', vm.editorConfig.plugins);
                    console.log('TinyMCE final toolbar:', vm.editorConfig.toolbar);
                    console.log('TinyMCE attrs:', vm.$attrs);
                    let content = vm.$slots.default

                    if (content) {
                        content = content[0].text;
                    } else {
                        content = ''
                    }
                    try {
                        if (vm.dirtyContent.length === 0) {
                            tinymce.get(vm.id).setContent(content);
                        } else {
                            tinymce.get(vm.id).setContent(vm.dirtyContent);
                        }

                    } catch (e) {
                        console.warn(`TinyMce Vue js error ${e}`)
                    }

                    $('#' + vm.id).val(content);
                    document.dispatchEvent(new CustomEvent(vm.id + '_tinymce_editor_initialized', {
                        "detail": {"editor": editor}
                    }));
                  const tinymceInstance = tinymce.get(vm.id);
                  if (tinymceInstance) {
                    tinymceInstance.on('keyup', function (e) {
                      vm.content = e.target.innerHTML.replaceAll(/<\/?[^>]+(>|$)/gi, "");
                    });
                  } else {
                    console.warn('TinyMCE editor instance not found');
                  }

                });
                // }, 1000);
            });
        },
        listenToSortable() {
            const vm = this;
            EventBus.$on('onSortableEnd', () => {
                let editor = tinymce.get(vm.id);

                setTimeout(() => {
                    editor.remove();
                }, 100);

                $('#' + vm.id).hide()

                this.$nextTick(() => {
                    vm.initTinyMCE();
                    $('#' + vm.id).show()
                })
            })
            EventBus.$on('onSortableStart', () => {
                let editor = tinymce.get(vm.id);
                this.dirtyContent = editor.getContent();
            })
        }
    },
    mounted() {
        const vm = this;
        const selector = '#' + vm.id;
        vm.editorConfig = jQuery.extend({
            deprecation_warnings: false,
            promotion: false,
            license_key: 'gpl',
            selector: selector,
            height: 400,
            indent: false,
            plugins: 'emoticons link image code preview lists',
            valid_children: '+body[style]',
            convert_urls: false,
            relative_urls: false,
            toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | numlist bullist | forecolor backcolor removeformat | preview code | image link emoticons | preview-btn',

            setup: function (editor) {
                editor.on('init', function () {
                    document.dispatchEvent(new CustomEvent(vm.id + '_tinymce_editor_loaded'));
                });

                editor.on('paste keyup change', function () {
                    var tinymceElem = tinymce.get(vm.id);

                    if (tinymceElem) {
                        let content = tinymceElem.getContent();
                        $('#' + vm.id).val(content);
                        vm.content = content;
                        EventBus.$emit('onServiceaAttribusteLongText', []);
                    }
                });
            },

            images_upload_handler: function (blobInfo, success, failure, progress) {
                vm.$store.dispatch("editor/getMe").then(function (me) {
                    let path;

                    if (vm.path == "" || vm.path == undefined) {
                        path = `summernote/company_${me.company_id}/`;
                    } else {
                        path = vm.path;
                    }

                    UploadS3File(path, blobInfo.blob()).then((path) => {
                        success(me.s3 + path);
                    });
                });
            },
        }, vm.$attrs);

// Important: remove unavailable plugins after vm.$attrs override
        vm.editorConfig.plugins = vm.cleanTinyMcePlugins(vm.editorConfig.plugins);

        delete vm.editorConfig.fullpage_default_encoding;

        console.log('TinyMCE cleaned plugins:', vm.editorConfig.plugins);
        $("#" + vm.id).ready(function () {
            vm.initTinyMCE();
        })
        this.listenToSortable();
    },

    watch: {
        content(value) {
            if ((value == "" || !value) && !this.isServiceDescription) {
                this.$el.querySelector("iframe").contentWindow.document.querySelector("[data-mce-placeholder]").setAttribute('data-mce-placeholder', this.placeholder)
                this.$el.querySelector("iframe").contentWindow.document.querySelector("[data-mce-placeholder]").setAttribute('aria-placeholder', this.placeholder)
                this.$emit('input', null)
                return
            }
            this.$emit('input', value)
        },
        placeholder(value) {
            this.$nextTick(() => {
                this.$el.querySelector("iframe").contentWindow.document.querySelector("[data-mce-placeholder]").setAttribute('data-mce-placeholder', value)
                this.$el.querySelector("iframe").contentWindow.document.querySelector("[data-mce-placeholder]").setAttribute('aria-placeholder', value)
            })
        },
    }
}
</script>
